const routes = [
  {
    path: '/black',
    name: '',
    redirect:'/black/list'
  },
  {
    path: '/black/list',
    name: '',
    meta:{
      module:'gold_action_manage',
      menu:'/black/list',
      title:'金标认证配置',
      keepAlive: true,
      breadcrumb: ['black'],
      menuBreadcrumb: 'black',
    },//menu 用于所属右侧菜单栏
    component: () => import('@/views/black/list.vue')
  },
]

export default routes;
